<template>
  <div>
    <!-- <div class="text-xs-right">
      <v-menu offset-y transition="slide-x-transition">
        <template v-slot:activator="{ on }">
          <v-badge overlap color="red">
          <template v-slot:badge>
          <span>{{totalExpireItem}}</span>
        </template>
          <v-icon
          large
          color="grey"
          v-on="on"
          >
          notifications
        </v-icon>
      </v-badge>
        </template>
        <v-list two-line>
          <template v-for="(item,index) in expireItem">
          <v-list-tile
            :key="index"
            @click="test(item)"
          >
          <v-list-tile-content>
            <v-list-tile-title>{{item.vehicle_name}}</v-list-tile-title>
            <v-list-tile-sub-title class="text--primary">{{ item.model_no }}</v-list-tile-sub-title>
          </v-list-tile-content>
          </v-list-tile>
          <v-divider
                v-if="index + 1 < expireItem.length"
                :key="index"
              ></v-divider>
          </template>
        </v-list>
      </v-menu>
    </div> -->

    <v-card color="grey lighten-4">
      <Snackbar :SnackbarVal="SnackbarVal"></Snackbar>
    </v-card>
    <v-container>
      <!-- Form -->
      <v-card>
        <v-card-title>
          <span class="headline">{{ formTitle }}</span>
        </v-card-title>
        <v-form v-model="valid" ref="form" lazy-validation>
          <v-card-text>
            <v-container grid-list-md>
              <v-layout wrap>
                 <v-flex xs12 sm12 md12>
                  <v-autocomplete
                    label="Asset Item"
                    item-text="item_name"
                    item-value="asset_id"
                    :items="assetItemList"
                    v-model="formSchema.asset_id"
                    :rules="[(v) => !!v || 'Field is required']"
                    required
                    @change="setPack($event)"
                  ></v-autocomplete>
                </v-flex>
                <v-flex xs12 sm6 md6>
                  <v-text-field
                    label="Vehicle Name"
                    v-model="formSchema.vehicle_name"
                    :rules="[v => !!v || 'Field is required']"
                    required
                  ></v-text-field>
                </v-flex>
                <v-flex xs12 sm6 md6>
                  <v-text-field
                    label="Model Number."
                    v-model="formSchema.model_no"
                    :rules="[v => !!v || 'Field is required']"
                    required
                  ></v-text-field>
                </v-flex>
                <v-flex xs12 sm4 md4>
                  <v-text-field
                    label="Engine no."
                    v-model="formSchema.engine_no"
                    :rules="[v => !!v || 'Field is required']"
                    required
                  ></v-text-field>
                </v-flex>
                 <v-flex xs12 sm4 md4>
                  <v-text-field
                    label="Registration Number"
                    v-model="formSchema.registration"
                    :rules="[v => !!v || 'Field is required']"
                    required
                  ></v-text-field>
                </v-flex>
                <v-flex xs12 sm4 md4>
                <DatePicker
                    :key="formSchema.id"
                    :inputData="{
                      index: 7,
                      fieldName: 'purchase_date',
                      fieldValue: formSchema.purchase_date,
                      label: 'Purchase Date'
                    }"
                    @setValue="setDateValue"
                  ></DatePicker>
                </v-flex>
                <v-flex xs12 sm3 md3>
                 <DatePicker
                    :key="formSchema.id"
                    :inputData="{
                      index: 1,
                      fieldName: 'fitness_issue_date',
                      fieldValue: formSchema.fitness_issue_date,
                      label: 'Car Fitness Issue Date'
                    }"
                    @setValue="setDateValue"
                  ></DatePicker>
                </v-flex>
                  <v-flex xs12 sm3 md3>
                  <DatePicker
                    :key="formSchema.id"
                    :inputData="{
                      index: 2,
                      fieldName: 'fitness_expire_date',
                      fieldValue: formSchema.fitness_expire_date,
                      label: 'Car Fitness Expiry Date',
                      disabled:'1'
                    }"
                    @setValue="setDateValue"
                    ref="setFitnessRange"
                  ></DatePicker>
                </v-flex>
                 <v-flex xs12 sm3 md3>
                <DatePicker
                    :key="formSchema.id"
                    :inputData="{
                      index: 3,
                      fieldName: 'insurance_issue_date',
                      fieldValue: formSchema.insurance_issue_date,
                      label: 'Insurance Policy Issue Date'
                    }"
                    @setValue="setDateValue"
                   
                  ></DatePicker>
                </v-flex>
                <v-flex xs12 sm3 md3>
                <DatePicker
                    :key="formSchema.id"
                    :inputData="{
                      index: 4,
                      fieldName: 'insurance_expire_date',
                      fieldValue: formSchema.insurance_expire_date,
                      label: 'Insurance Policy Expiry Date',
                      disabled:'1'
                    }"
                    @setValue="setDateValue"
                     ref="setInsuranceRange"
                  ></DatePicker>
                </v-flex>
                 <v-flex xs12 sm4 md4>
                <DatePicker
                    :key="formSchema.id"
                    :inputData="{
                      index: 5,
                      fieldName: 'tax_issue_date',
                      fieldValue: formSchema.tax_issue_date,
                      label: 'TAX Token Issue Date'
                    }"
                    @setValue="setDateValue"
                  ></DatePicker>
                </v-flex>
                <v-flex xs12 sm4 md4>
                <DatePicker
                    :key="formSchema.id"
                    :inputData="{
                      index: 6,
                      fieldName: 'tax_expire_date',
                      fieldValue: formSchema.tax_expire_date,
                      label: 'TAX Token Expiry Date',
                      disabled:'1'
                    }"
                    @setValue="setDateValue"
                    ref="setTaxRange"
                  ></DatePicker>
                </v-flex>
                
                <v-flex xs12 sm4 md4>
                  <v-text-field
                    label="Package Number."
                    v-model="formSchema.package_id"
                    :rules="[v => !!v || 'Field is required']"
                    required
                  ></v-text-field>
                </v-flex>
               
               
                 <v-flex xs12 sm4 md4>	
								     <v-checkbox v-model="formSchema.active" label="Active" :value="isActiveVal"></v-checkbox>
									</v-flex>
                  <v-flex xs12 sm12 md12>
                  <v-text-field
                    label="Remarks"
                    v-model="formSchema.remarks"

                  ></v-text-field>
                </v-flex>
                <v-flex xs12 sm4 md4>
                  <label for="">Document-01</label>
                  <input type="file" @change="getImage" id="doc01" class="form-control"/>
                </v-flex>

                <v-flex xs12 sm4 md4>
                  <label for="">Document-02</label>
                  <input type="file" @change="getFile2" id="doc02" class="form-control" />
                </v-flex>

                <v-flex xs12 sm4 md4>
                  <label for="">Document-03</label>
                  <input type="file" @change="getFile3" id="doc03" class="form-control" />
                </v-flex>
              </v-layout>
            </v-container>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              color="success"
              @click.native="validateBeforeSubmit"
              >{{btnTitle}}</v-btn
            >
            <v-btn color="error" @click.native="reset">Reset</v-btn>
          </v-card-actions>
        </v-form>
      </v-card>
      <!-- /Form -->
    </v-container>
  </div>
</template>
<script>
/**
 * ---------------------
 *  implements by majeed
 * ---------------------
 */
const commonService = require("../../../services/common.service");
import DatePicker from "../../global/date_picker";

import { preFix } from "../../../vuex/api";
import Axios from "axios";
export default {
  components: {
    DatePicker
  },
  props: ["formSchema"],
  data: () => ({
    show: true,
    valid: true,
    dialog: false,
    dialogEditForm: false,
    isActiveVal: 0,
    search: "",
    totalItems: 0,
    loading: true,

    pagination: {
      sortBy: "id",
      descending: true
    },
   
    selected: [],
    search: "",
    headers: [
      {
        text: "Name",
        align: "left",
        sortable: false,
        value: "name"
      },
      { text: "User Type", align: "left", value: "type_id" },
      { text: "Email", value: "email" }
    ],
     
  SnackbarVal: {
      snackbar: false,
      color: "success",
      message: "",
    },
    areaList: [
      { id: 1, text: "Dhaka" },
      { id: 2, text: "Chattogram" },
      { id: 3, text: "Khulna" },
      { id: 4, text: "Syhlet" },
      { id: 5, text: "Barisal" },
      { id: 6, text: "Rajshahi" },
      { id: 7, text: "Feni" }
    ],

    delete_id: "",
    row_index: "",
    dialog2: false,
    snackbar: false,
    color: "success",
    mode: "",
    timeout: 3000,
    left: "left",
    message: "",
    doc_file: '',
    select: null,
    assetItemList: [],
    expireItem:[],
    totalExpireItem:0,
    typelist: [],

    instituteShow: true
  }),

  computed: {
    formTitle() {
      return this.formSchema.id > 0
        ? "Update Project's Vehicle"
        : "Add Project's Vehicle";
    },
    btnTitle() {
      return this.formSchema.id > 0
        ? "Update"
        : "Save";
    }
  },

  created() {
     commonService.getAllData('get_asset_item_in_vehicle').then(res => {                                    
        this.assetItemList = res.data;
        this.loading = false;
      });
      // commonService.getAllData('vehicle-expire-notification').then(res =>{
  
      //   let vehicleItem = res.data
      //   let tempItem = []
      //   vehicleItem.forEach((c,i,f) => {
      //     if(c.fit_days <= 30 || c.ins_days <= 30 || c.tax_days <= 30){
      //        tempItem.push(c)
      //     }
      //   })
      //   this.expireItem = tempItem
      //   this.totalExpireItem = this.expireItem.length
      //   this.loading = false

      // })
  },

  methods: {
    test(item){
      let stringifyItem = JSON.stringify(item)

      sessionStorage.setItem("vehicleInfo", stringifyItem); 
      this.$router.push('vehicle-expiry-details')
    },
    setDateValue(data) {
      let index = data.index;
      this.formSchema[data.fieldName] = data.value;
       if(data.fieldName == "fitness_issue_date"){
        this.formSchema.fitness_expire_date = 0
        this.$refs.setFitnessRange.setRange(data.value);
      }
      if(data.fieldName == "insurance_issue_date"){
        this.formSchema.insurance_expire_date = 0
        this.$refs.setInsuranceRange.setRange(data.value);
      }
      if(data.fieldName == "tax_issue_date"){
        this.formSchema.tax_expire_date = 0
        this.$refs.setTaxRange.setRange(data.value);
      }
    },
    
    getImage(e){
       let fileReader = new FileReader();
       fileReader.readAsDataURL(e.target.files[0])
       fileReader.onload = (e) => {
          this.formSchema.document_01 = e.target.result        
       }
       
    },
    getFile2(e){
       let fileReader02 = new FileReader();
       fileReader02.readAsDataURL(e.target.files[0])
       fileReader02.onload = (e) => {
          this.formSchema.document_02 = e.target.result
       }
       
    },
    getFile3(e){
       let fileReader03 = new FileReader();
       fileReader03.readAsDataURL(e.target.files[0])
       fileReader03.onload = (e) => {
          this.formSchema.document_03 = e.target.result          
       }
       
    },
    validateBeforeSubmit(e) {
      var formSchema = this.formSchema;
      formSchema.record_id = sessionStorage.getItem("mm_id");
      formSchema.sub_menu_id = sessionStorage.getItem("sm_id");
      var root = this;
      if (this.$refs.form.validate()) {
        formSchema.purchase_date = formSchema.purchase_date == "" ? "" : root.changeFormateYMD(
        formSchema.purchase_date
        );
        formSchema.fitness_issue_date = formSchema.fitness_issue_date == "" ? "" : formSchema.fitness_issue_date == null ? "": root.changeFormateYMD(
        formSchema.fitness_issue_date
        );
        formSchema.fitness_expire_date = formSchema.fitness_expire_date == "" ? "" : formSchema.fitness_expire_date == 0 ? "": formSchema.fitness_expire_date == null ? "": root.changeFormateYMD(
        formSchema.fitness_expire_date
        );
        formSchema.insurance_issue_date = formSchema.insurance_issue_date == "" ? "" : formSchema.insurance_issue_date == null ? "": root.changeFormateYMD(
        formSchema.insurance_issue_date
        );
        formSchema.insurance_expire_date = formSchema.insurance_expire_date == "" ? "" : formSchema.insurance_expire_date == 0 ? "": formSchema.insurance_expire_date == null ? "": root.changeFormateYMD(
        formSchema.insurance_expire_date
        );
        formSchema.tax_issue_date = formSchema.tax_issue_date == "" ? "" : formSchema.tax_issue_date == null ? "": root.changeFormateYMD(
        formSchema.tax_issue_date
        );
        formSchema.tax_expire_date = formSchema.tax_expire_date == "" ? "" : formSchema.tax_expire_date == 0 ? "": formSchema.tax_expire_date == null ? "": root.changeFormateYMD(
        formSchema.tax_expire_date
        );
        if (formSchema.id > 0) {
          commonService
            .updateFormData(this.formSchema, "vehicle_info")
            .then(res => {
              if (res.status == 1) {
                document.getElementById('doc01').value= null;
                document.getElementById('doc02').value= null;
                document.getElementById('doc03').value= null;
                this.formSchema.purchase_date = ''
                this.formSchema.fitness_issue_date = ''
                this.formSchema.fitness_expire_date = ''
                this.formSchema.insurance_issue_date = ''
                this.formSchema.insurance_expire_date = ''
                this.formSchema.tax_issue_date = ''
                this.formSchema.tax_expire_date = ''

                let actionData = {
							message: res.message,
							data: res.data,
							action: "edit",
							status: res.status
							};
							this.close(actionData);
              }
            });
        } else {
          commonService
            .insertFormData(this.formSchema, "vehicle_info")
            .then(res => {
              //console.log(res);
              if (res.status == 1) {
                this.formSchema.purchase_date = ''
                this.formSchema.fitness_issue_date = ''
                this.formSchema.fitness_expire_date = ''
                this.formSchema.insurance_issue_date = ''
                this.formSchema.insurance_expire_date = ''
                this.formSchema.tax_issue_date = ''
                this.formSchema.tax_expire_date = ''
                document.getElementById('doc01').value= null;
                document.getElementById('doc02').value= null;
                document.getElementById('doc03').value= null;
                let actionData = {
							message: res.message,
							data: res.data,
							action: "add",
							status: res.status
							};
							this.close(actionData);
              }
            });
        }
      }
    },
    close:function(message){
				 if(message.status==1)
      			 {
				 this.$refs.form.reset();
				 }				
				this.$emit('reloadData', message)
      },
      reset(){
				 if (this.formSchema.id > 0) {
        close(0);
      } else {
        this.$refs.form.reset();
      }

      },
      setPack(e){
        let asset_id = e;
        let single_item = this.assetItemList.find((c) => c.asset_id == asset_id)
        single_item.purchase_date = this.changeFormateDMY(single_item.purchase_date)
        this.formSchema.purchase_date = single_item.purchase_date
        this.formSchema.package_id = single_item.package_no
      }
  },

  watch: {
    // props re-activity
    formSchema() {
        // document.getElementById('doc01').value= this.formSchema.document_01;
    }
  },

  mounted() {}
};
</script>



// WEBPACK FOOTER //
// src/components/administration/vehicle_info/vehicle_info_entry.vue